module.exports = __webpack_public_path__ + "img/ld_6@2x.2a4be0a0.png";